import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Ezyclass là gì?",
    a: "Ezyclass là phần mềm quản lý trung tâm học tập trực tuyến dành cho Việt Nam. Quản lý học viên, giáo viên, lớp học, điểm danh, bài tập, học phí và báo cáo — tất cả trên một nền tảng.",
  },
  {
    q: "Tôi có thể dùng thử trước khi mua không?",
    a: "Có! Bấm 'Xem demo' để trải nghiệm ngay với dữ liệu mẫu 1000+ học viên, 30 lớp học. Không cần đăng ký, không cần thanh toán.",
  },
  {
    q: "Ezyclass phù hợp với loại trung tâm nào?",
    a: "Mọi loại hình: luyện thi, ngoại ngữ, âm nhạc, mỹ thuật, tin học, gia sư cá nhân, trường tư thục. Từ 10 đến hàng nghìn học viên.",
  },
  {
    q: "Học viên và giáo viên có cần cài ứng dụng không?",
    a: "Không. Ezyclass chạy trên trình duyệt web, dùng được trên điện thoại, tablet và máy tính. Admin tạo tài khoản cho mọi người.",
  },
  {
    q: "Dữ liệu có an toàn không?",
    a: "Dữ liệu được lưu trên hạ tầng Google Cloud với mã hóa SSL, Row Level Security và backup tự động. Mỗi trung tâm có dữ liệu riêng biệt.",
  },
  {
    q: "Có thể nâng cấp hoặc hạ cấp gói không?",
    a: "Có. Thay đổi gói bất kỳ lúc nào. Nâng cấp trả chênh lệch, hạ cấp tính vào chu kỳ tiếp.",
  },
  {
    q: "Hỗ trợ phương thức thanh toán nào?",
    a: "Chuyển khoản ngân hàng, Momo, VNPay và thẻ quốc tế. Gói Trường học và Enterprise có hóa đơn VAT.",
  },
  {
    q: "Cần hỗ trợ triển khai thì liên hệ ai?",
    a: "Email infoezyclass@gmail.com hoặc gọi 0965 108 401. Đội ngũ Ezyclass sẽ hỗ trợ triển khai 1-1 cho trung tâm của bạn.",
  },
];

export function LandingFAQ() {
  return (
    <section id="faq" className="bg-white dark:bg-slate-900 py-24 md:py-32 px-4">
      <div className="max-w-3xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6, ease: [0.32, 0.72, 0, 1] }}
        >
          <div className="text-center mb-12">
            <div className="inline-flex px-3.5 py-1.5 rounded-full bg-amber-50 dark:bg-amber-500/10 ring-1 ring-amber-100 text-[11px] uppercase tracking-[0.15em] font-medium text-amber-700 dark:text-amber-300 mb-4">
              FAQ
            </div>
            <h2 className="font-display text-3xl md:text-5xl font-bold tracking-tight text-slate-900 dark:text-white">
              Câu hỏi thường gặp
            </h2>
          </div>

          <Accordion type="single" collapsible className="w-full space-y-3">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                className="rounded-2xl bg-white dark:bg-slate-900 ring-1 ring-black/[0.04] dark:ring-white/10 shadow-[0_4px_20px_rgb(0,0,0,0.02)] px-5 border-none transition-shadow duration-500 hover:shadow-[0_8px_30px_rgb(0,0,0,0.04)]"
              >
                <AccordionTrigger className="text-left text-[15px] font-semibold text-slate-900 dark:text-white hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-500 dark:text-slate-400 text-[14.5px] leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}

